export default __webpack_public_path__ + "static/media/protoAndGoIcon.0094e3ab.png";